import 'reset-css';
import React from 'react';
import ReactDOM from 'react-dom';
import { MbmProvider } from '@amzn/react-arb-tools';

import App from './components/App';
import AppInitWrapper from './components/AppInitWrapper';
import { LocaleProvider, useLocale } from './context/LocaleContext';
import { getLocalizationContext } from './helpers';
import arbManifest from './i18n/translations/arbManifest';
import { DEFAULT_LOCALE, TRANSLATION_ROUTE } from './constants';
import { metricsHelper } from './metrics';
import './logger';

import './index.scss';

// Initialize metrics helper with URL parameters
// This extracts site_code, login_method, and stage dimensions
// that will be included in all subsequent metrics
metricsHelper.initializeFromUrl();

const resolveBundleUrl = (resourcePackPath: string | undefined, _locale: string, _bundle: string) => {
    return resourcePackPath ? `${TRANSLATION_ROUTE}/${resourcePackPath}` : undefined;
};

// Wrapper component to connect LocaleContext with MbmProvider
const TranslationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { locale } = useLocale();
    const localizationContext = getLocalizationContext(locale);

    return (
        <MbmProvider
            key={locale}
            arbManifest={arbManifest}
            resolveBundleUrl={resolveBundleUrl}
            defaultLocalizationContext={localizationContext}
        >
            {children}
        </MbmProvider>
    );
};

ReactDOM.render(
    <React.StrictMode>
        <AppInitWrapper>
            <LocaleProvider>
                <TranslationProvider>
                    <React.Suspense fallback={<></>}>
                        <App />
                    </React.Suspense>
                </TranslationProvider>
            </LocaleProvider>
        </AppInitWrapper>
    </React.StrictMode>,
    document.getElementById('root')
);
